var React = require('react'),
    ReactDOM = require('react-dom');

var vdom = React;
vdom.DOM = ReactDOM;

module.exports = {
   VDOM: vdom
};

